import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../basic/index.jsx';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetLogQuery } from '../../../../redux/services/logs.jsx';
import { Spinner } from '../../../common/index.jsx';
import dayjs from 'dayjs';
import CollapseBlock from '../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
const LogsDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: logsDetail, isLoading } = useGetLogQuery(id);

  useEffect(() => {
    document.title = t('Detail operácie') + ' - FRI CMS';
  }, []); // Runs on mount

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Detail operácie')}
        backUrl={routes.cmsLogs}
        backUrlTooltip={t('Logy')}
        permissionsBasic={'logs'}
      />
      <div>
        <CollapseBlock collapsible title={t('Základné informácie')}>
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <td>
                  <b>{t('Operácia')}</b>
                </td>
                <td>{logsDetail.event}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Dátum')}</b>
                </td>
                <td>
                  {dayjs(logsDetail.created_at).format('DD.MM.YYYY HH:mm:ss')}
                </td>
              </tr>
              <tr>
                <td>
                  <b>{t('Objekt')}</b>
                </td>
                <td>{logsDetail.subject_type}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('ID Objektu')}</b>
                </td>
                <td>{logsDetail.subject_id}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Meno používateľa')}</b>
                </td>
                <td>{logsDetail.causer_name || t('Neznámy')}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Typ požívateľa')}</b>
                </td>
                <td>{logsDetail.causer_type || t('Neznámy')}</td>
              </tr>
            </tbody>
          </table>
        </CollapseBlock>

        <CollapseBlock collapsible title={t('Vlastnosti pred operáciou')}>
          {logsDetail.properties_old ? (
            <pre>{JSON.stringify(logsDetail.properties_old, null, 2)}</pre>
          ) : (
            <p>{t('Žiadne pôvodné vlastnosti')}</p>
          )}
        </CollapseBlock>

        <CollapseBlock collapsible title={t('Vlastnosti po operácii')}>
          {logsDetail.properties_new ? (
            <pre>{JSON.stringify(logsDetail.properties_new, null, 2)}</pre>
          ) : (
            <p>{t('Žiadne nové vlastnosti')}</p>
          )}
        </CollapseBlock>
      </div>
    </>
  );
};

export default LogsDetail;
